import { ColorTag } from "@knowfully/ui.common";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function ColorPreview({
  metaValueName,
  displayText,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const color = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  if (!color) return null;

  return <ColorTag hex={color} text={displayText ?? ""} />;
}
